
import { useState } from "react";
import { useHistory } from "react-router-dom";
//import { Redirect } from "react-router-dom";

import api from "../../services/api";
import Footer from "../../components/Footer";
import NavBar from "../../components/NavBar";
import Cargos from "../../components/cargoOption"
import Filiais from "../../components/filialOption"
import Estados from "../../components/estados"
import Uf from "../../components/uf"
//import { render } from "@testing-library/react";

const Curriculum = () => {
    const history = useHistory();

    const initialValue = {
        cpf: '',
        cargo: '',
        pretencaoSalarial: 0,
        nome: '',
        estadoCivil: '',
        dataNascimento: '',
        naturalidade: '',
        temFilhos: '',
        quantosFilhos: '',
        endereco: '',
        bairro: '',
        cidade: '',
        estado: '',
        tipoMoradia: '',
        nomeMae: '',
        profissaoMae: '',
        nomePai: '',
        profissaoPai: '',
        escolaridade: '',
        esocolaridadeAno: '',
        status: '',
        statusSno: '',
        pis: '',
        primeiroEmprego: '',
        rg: '',
        orgaoRg: '',
        ufRg: '',
        dataRg: '',
        temCnh: '',
        numeroCnh: '',
        categoriaCnh: '',
        validadeCnh: '',
        telefoneContato: '',
        celularContato: '',
        nomeRecado: '',
        telefoneRecado: '',
        email: '',
        ultimaEmpresa: '',
        contatoUltimaEmpresa: '',
        cargoUltimaEmpresa: '',
        inicioUltimaEmpresa: '',
        finalUlrimaEmpresa: '',
        salarioUltimaEmpresa: '',
        comissaoUltimaEmpresa: '',
        promovidoUltimaEmpresa: '',
        atividadesUltimaEmpresa: '',
        tipoSaidaUltimaEmpresa: '',
        motivoSaidaUltimaEmpresa: '',
        penultimaEmpresa: '',
        contatoPenultimaEmpresa: '',
        cargoPenultimaEmpresa: '',
        inicioPenultimaEmpresa: '',
        finalPenulrimaEmpresa: '',
        salarioPenultimaEmpresa: '',
        comissaoPenultimaEmpresa: '',
        promovidoPenultimaEmpresa: '',
        atividadesPenultimaEmpresa: '',
        tipoSaidaPenultimaEmpresa: '',
        motivoSaidaPenultimaEmpresa: '',
        antepenultimaEmpresa: '',
        contatoAntepenultimaEmpresa: '',
        cargoAntepenultimaEmpresa: '',
        inicioAntepenultimaEmpresa: '',
        finalAntepenulrimaEmpresa: '',
        salarioAntepenultimaEmpresa: '',
        comissaoAntepenultimaEmpresa: '',
        promovidoAntepenultimaEmpresa: '',
        atividadesAntepenultimaEmpresa: '',
        tipoSaidaAntepenultimaEmpresa: '',
        motivoSaidaAntepenultimaEmpresa: '',
        dataCriacao: '',
        dataAtualizacao: ''
    }
    
    const [campos, setCampos] = useState(initialValue);
    
    function handleInputChange(event){
        campos[event.target.name] = event.target.value;
        setCampos(campos);
    }

    function handleInputDecimalChange(event){
        campos[event.target.name] = parseFloat(event.target.value).toFixed(2);
        setCampos(campos);
    }

    function enviarDados(event){
        event.preventDefault();
        api.post('/curriculums', campos).then(response => {
            console.log(campos);
            //alert('Cadastro realizado com sucesso!');
            //window.location.href = "http://localhost:3000/confirmacao";
            history.push("/confirmacao");
            
    }).catch(error => {
        if(error.message === "Request failed with status code 409") {
            alert('CPF inválido, verifique!');
        } else {
            alert('Cadastro não realizado, verifique os dados informados!');
        }
    });
    }

    return (
        <>  
            <form onSubmit={enviarDados}>
            <NavBar />
            <div className="container">
                <div className="jumbotron">
                    <h1 className="display-4">Banco de Talentos do Dom</h1>
                    <p className="lead">O preenchimento deste formulário não assegura ao candidato sua admissão do Dom Atacadista, mas apenas
                        a concorrência a uma eventual vaga.</p>
                </div>
                    <div className="card">
                        <div className="h4 card-header text-center col-md-12 bg-primary">
                            Pretensão Profissional
                        </div>
                        <div className="form-row pl-1 pr-1">
                        <div className="form-group col-md-5">
                            <label for="cargoDesejado" class="required">Cargo</label>
                            <select className="form-control" id="cargoDesejado" name="cargo" required onChange={handleInputChange}>
                                <Cargos/>
                            </select>
                        </div>
                        <div className="form-group col-md-5">
                            <label class="required">Loja Preferencial</label>
                            <select className="form-control" id="empresaPreferencia" name="empresaPreferencia" required onChange={handleInputChange}>
                                <Filiais/>
                            </select>
                        </div>
                        <div className="form-group col-md-2">
                            <label >Salário</label>
                            <input type="number" className="form-control" id="inputSalario" placeholder="Salário" name="pretencaoSalarial" min="0" pattern="^\d*(\.\d{0,2})?$" onChange={handleInputDecimalChange} />
                        </div>
                    </div>
                    </div>
                    <br />
                    <div className="card">
                        <div className="h4 card-header text-center col-md-12 bg-primary">
                            Identificação Pessoal
                        </div>
                        <div className="form-row pl-1 pr-1">
                            <div className="form-group col-md-12">
                                <label class="required">Nome Completo</label>
                                <input type="text" className="form-control" id="inputName" placeholder="Nome Completo" name="nome" maxLength="60" required onChange={handleInputChange} />
                            </div>
                        </div>

                        <div className="form-row pl-1 pr-1">
                            <div className="form-group col-md-6">
                                <label class="required">Estado Civil</label>
                                <div className="text-center">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="casado" name="estadoCivil" className="form-check-input  " value="Casado"  required onChange={handleInputChange}/>
                                        <label className="form-check-label">Casado</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="divorciado" name="estadoCivil" className="form-check-input" value="Divorciado" required onChange={handleInputChange}/>
                                        <label className="form-check-label" >Divorciado</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="solteiro" name="estadoCivil" className="form-check-input" value="Solteiro" required onChange={handleInputChange}/>
                                        <label className="form-check-label" >Solteiro</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="viuvo" name="estadoCivil" className="form-check-input" value="Viuvo" required onChange={handleInputChange}/>
                                        <label className="form-check-label" >Viúvo</label>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group col-md-2">
                                <label class="required">Sexo</label>
                                <select className="form-control" id="sexo" name="sexo" required onChange={handleInputChange}>
                                    <option value="" selected >Selecione o sexo...</option>
                                    <option value="Masculino">Masculino</option>
                                    <option value="Feminino">Feminino</option>
                                </select>
                            </div>

                            <div className="form-group col-md-4">
                                <label class="required">Data de Nascimento</label>
                                <input type="date" className="form-control" id="inputNascimento" name="dataNascimento" required onChange={handleInputChange}/>
                            </div>

                            <div className="form-group col-md-3">
                                <label class="required">Naturalidade</label>
                                <input type="text" className="form-control" id="inputNaturalidade" placeholder="Naturalidade" maxLength="15" name="naturalidade" required onChange={handleInputChange}/>
                            </div>
                            <div className="form-group col-md-3">
                                <label class="required">Tem Filhos?</label>
                                <div className="text-center">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="casado" name="temFilhos" className="form-check-input  " value="Sim"  required onChange={handleInputChange}/>
                                        <label className="form-check-label">Sim</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="temFilhos" name="temFilhos" className="form-check-input" value="Não" required onChange={handleInputChange}/>
                                        <label className="form-check-label" >Não</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group col-md-6">
                                <label >Quantos?</label>
                                <input type="text" className="form-control" id="inputQtdFilhos" placeholder="Quantos filhos?" maxLength="3" name="quantosFilhos" onChange={handleInputChange}/>
                            </div>

                            <div className="form-group col-md-7">
                                <label class="required">Endereço</label>
                                <input type="text" className="form-control" id="endereco" maxLength="60" placeholder="Endereço" name="endereco" required onChange={handleInputChange}/>
                            </div>
                            <div className="form-group col-md-2">
                                <label class="required">CEP</label>
                                <input type="number" className="form-control" id="CEP" maxLength="60" placeholder="CEP" name="cep" required onChange={handleInputChange}/>
                            </div>
                            <div className="form-group col-md-3">
                                <label class="required">Bairro</label>
                                <input type="text" className="form-control" id="bairro" maxLength="60" placeholder="Bairro" name="bairro" required onChange={handleInputChange}/>
                            </div>

                            <div className="form-group col-md-3">
                                <label class="required">Município</label>
                                <input type="text" className="form-control" id="municipio" maxLength="60" placeholder="Município" name="cidade" required onChange={handleInputChange}/>
                            </div>
                            <div className="form-group col-md-3">
                                <label class="required">Estado</label>
                                <select className="form-control" id="estado" name="estado" maxLength="60" required onChange={handleInputChange}>
                                    <Estados/>
                                </select>
                            </div>
                            <div className="form-group col-md-6">
                                <label class="required">Tipo de Moradia</label>
                                <div className="text-center">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="cedida" className="form-check-input  " value="Cedida"  name="tipoMoradia" onChange={handleInputChange}/>
                                        <label className="form-check-label">Cedida</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="aluguda" className="form-check-input" value="Alugada" name="tipoMoradia" onChange={handleInputChange}/>
                                        <label className="form-check-label" >Alugada</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="propria" className="form-check-input" value="Própria" name="tipoMoradia" onChange={handleInputChange}/>
                                        <label className="form-check-label" >Própria</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className="card ">
                        <div className="h4 card-header text-center col-md-12 bg-primary">
                            Filiação
                        </div>

                        <div className="form-row pl-1 pr-1">
                            <div className="form-group col-md-9">
                                <label class="required">Nome da Mãe</label>
                                <input type="text" className="form-control" id="inputMae" placeholder="Nome da Mãe" name="nomeMae" maxLength="60" required onChange={handleInputChange}/>
                            </div>
                            <div className="form-group col-md-3">
                                <label >Profissão</label>
                                <input type="text" className="form-control" id="inputProfissaoMae" maxLength="30" placeholder="Profissão" name="profissaoMae" onChange={handleInputChange}/>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group col-md-9">
                                <label class="required">Nome do Pai</label>
                                <input type="text" className="form-control" id="inputPai" placeholder="Nome do Pai" name="nomePai" maxLength="60" required onChange={handleInputChange}/>
                            </div>
                            <div className="form-group col-md-3">
                                <label >Profissão</label>
                                <input type="text" className="form-control" id="inputProfissaoPai" maxLength="30" placeholder="Profissão" name="profissaoPai" onChange={handleInputChange}/>
                            </div>
                        </div>
                    </div>

                    <br />

                    <div className="card">
                        <div className="h4 card-header text-center col-md-12 bg-primary">
                            Formação Escolar
                        </div>

                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group col-md-10">
                                <label class="required">Escolaridade</label>
                                <div className="form-group text-center col-md-10">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="fundamental" className="form-check-input  " value="Fundamental" name="escolaridade" required onChange={handleInputChange}/>
                                        <label className="form-check-label">Ensino Fundamental</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="medio" className="form-check-input  " value="Médio" name="escolaridade" required onChange={handleInputChange}/>
                                        <label className="form-check-label">Ensino Médio</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="superior" className="form-check-input  " value="Superior" name="escolaridade" required onChange={handleInputChange}/>
                                        <label className="form-check-label">Ensino Superior</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group col-md-2">
                                <label >Conclusão</label>
                                <input type="number" className="form-control" id="inputAnoConclusao" maxLength="4" placeholder="Ano" name="escolaridadeAno" onChange={handleInputChange}/>
                            </div>
                        </div>


                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group col-md-10">
                                <label class="required">Status</label>
                                <div className="form-group text-center col-md-10">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="Trancado" className="form-check-input  " value="Trancado"  name="status" onChange={handleInputChange}/>
                                        <label className="form-check-label">Trancado</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="Em Andamento" className="form-check-input  " value="Andamento" name="status" onChange={handleInputChange}/>
                                        <label className="form-check-label">Em Andamento</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="Concluído" className="form-check-input  " value="Concluído" name="status" onChange={handleInputChange}/>
                                        <label className="form-check-label">Concluído</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group col-md-2">
                                <label >Conclusão Status</label>
                                <input type="number" className="form-control" id="inputAnoConclusao" maxLength="4" placeholder="Ano" name="statusAno" onChange={handleInputChange}/>
                            </div>
                        </div>
                    </div>

                    <br />

                    <div className="card">
                        <div className="h4 card-header text-center col-md-12 bg-primary">
                            Documentos
                        </div>

                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-2">
                                <label class="required">CPF</label>
                                <input type="text" className="form-control" id="inputCPF" placeholder="CPF" name="cpf" required onChange={handleInputChange}/>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label class="required">PIS</label>
                                <input type="text" className="form-control" id="inputPIS" placeholder="PIS" name="pis" maxLength="15" onChange={handleInputChange}/>
                            </div>
                            <div className="form-group form-group col-md-6">
                                <label class="required">Primeiro Emprego?</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="primeirosim" className="form-check-input  " value="Sim"  name="primeiroEmprego" required onChange={handleInputChange}/>
                                        <label className="form-check-label">Sim</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="primeironao" className="form-check-input  " value="Não" name="primeiroEmprego" required onChange={handleInputChange}/>
                                        <label className="form-check-label">Não</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="form-row pl-1 pr-1">
                            <div className="form-group form-group col-md-2">
                                <label class="required">RG</label>
                                <input type="text" className="form-control" id="inputRG" maxLength="12" placeholder="RG" name="rg" required onChange={handleInputChange}/>
                            </div>
                            <div className="form-group form-group col-md-2">
                                <label class="required">Orgão Expedidor</label>
                                <input type="text" className="form-control" id="inputOrgao" maxLength="10" placeholder="Orgão Expedidor" name="orgaoRg" required onChange={handleInputChange}/>
                            </div>
                            <div className="form-group form-group col-md-2">
                                <label class="required">UF Expedidor</label>
                                <select className="form-control" id="inputUfOrgao" maxLength="2" name="ufRg" required onChange={handleInputChange}>
                                    <Uf/>
                                </select>
                            </div>
                            <div className="form-group form-group col-md-6">
                                <label class="required">Data de Emissão</label>
                                <input type="date" className="form-control" id="inputDataRG" name="dataRg" required onChange={handleInputChange}/>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1">
                            <div className="form-group form-group col-md-3">
                                <label class="required">Possuí CNH?</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="cnhsim" className="form-check-input  " value="Sim"  name="temCnh" required onChange={handleInputChange}/>
                                        <label className="form-check-label">Sim</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="cnhnao" className="form-check-input  " value="Não" name="temCnh" required onChange={handleInputChange}/>
                                        <label className="form-check-label">Não</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Nº CNH</label>
                                <input type="number" className="form-control" id="inputNumCNH" placeholder="Número da CNH" name="numeroCnh" maxLength="20" onChange={handleInputChange}/>
                            </div>
                            <div className="form-group form-group col-md-2">
                                <label >Categoria</label>
                                <input type="text" className="form-control" id="inputCategoria" maxLength="3" placeholder="Cat. CNH" name="categoriaCnh" onChange={handleInputChange}/>
                            </div>
                            <div className="form-group form-group col-md-3">
                                <label >Validade CNH</label>
                                <input type="date" className="form-control" id="inputDataCNH" name="validadeCnh" onChange={handleInputChange}/>
                            </div>
                        </div>
                    </div>

                    <br />

                    <div className="card">
                        <div className="h4 card-header text-center col-md-12 bg-primary">
                            Contatos
                        </div>

                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-2">
                                <label class="required">Celular</label>
                                <input type="text" className="form-control" id="inputCelular" maxLength="15" placeholder="(21)123457089" name="celularContato" required onChange={handleInputChange}/>
                            </div>
                            <div className="form-group form-group col-md-2">
                                <label >Telefone</label>
                                <input type="text" className="form-control" id="inputTelefone" maxLength="15" placeholder="(21)23457089" name="telefoneContato" onChange={handleInputChange}/>
                            </div>
                            <div className="form-group form-group col-md-6">
                                <label class="required">Nome para Recado</label>
                                <input type="text" className="form-control" id="inputNomeRecado" maxLength="30" placeholder="Nome para Recado" name="nomeRecado" required onChange={handleInputChange}/>
                            </div>
                            <div className="form-group form-group col-md-2">
                                <label class="required">Telefone Recado</label>
                                <input type="text" className="form-control" id="inputTelefoneRecado" maxLength="15" placeholder="(21)23457089" name="telefoneRecado" required onChange={handleInputChange}/>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-12">
                                <label class="required">e-mail</label>
                                <input type="text" className="form-control" id="inputEmail" maxLength="60" placeholder="contato@gmail.com" name="email" required onChange={handleInputChange}/>
                            </div>
                        </div>
                    </div>

                    <br />

                    <div className="card">
                        <div className="h4 card-header text-center col-md-12 bg-primary">
                            Experiência Profissional
                        </div>
                        <div className="h6 card-header text-left col-md-12 bg-secondary">
                            Última ou Atual(Opcional)
                        </div>
                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-8">
                                <label >Empresa</label>
                                <input type="text" className="form-control" id="inputEmpresaAtual" placeholder="Atual ou Última empresa" maxLength="60" name="ultimaEmpresa" onChange={handleInputChange}/>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Contato</label>
                                <input type="text" className="form-control" id="inputContaroEmpresaAtual" placeholder="Contato da empresa" maxLength="48" name="contatoUltimaEmpresa" onChange={handleInputChange}/>
                            </div>
                        </div>

                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-8">
                                <label >Cargo</label>
                                <input type="text" className="form-control" id="inputCargoEmpresaAtual" placeholder="Cargo ocupado" name="cargoUltimaEmpresa" maxLength="50" onChange={handleInputChange}/>
                            </div>

                            <div className="form-group form-group col-md-4">
                                <label >Período</label>
                                <div className="form-row pl-1 pr-1 ">
                                    <input type="date" className="form-control col-md-6 pl-1 pr-1" id="inputData1" name="inicioUltimaEmpresa" onChange={handleInputChange}/>
                                    <input type="date" className="form-control col-md-6 pl-1 pr-1" id="inputData2" name="finalUltimaEmpresa" onChange={handleInputChange}/>
                                </div>
                            </div>
                        </div>


                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-4">
                                <label >Salário</label>
                                <input type="number" className="form-control" id="inputSalarioEmpresaAtual" placeholder="Último salário" pattern="^\d*(\.\d{0,2})?$" name="salarioUltimaEmpresa" onChange={handleInputDecimalChange}/>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Recebia Comissão?</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="ComissaoCargo1Sim" className="form-check-input  " value="Sim"  name="comissaoUltimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Sim</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="ComissaoCargo1Nao" className="form-check-input  " value="Não" name="comissaoUltimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Não</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Foi Promovido?</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="PromovidoCargo1Sim" className="form-check-input  " value="Sim"  name="promovidoUltimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Sim</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="PromovidoCargo1Nao" className="form-check-input  " value="Não" name="promovidoUltimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Não</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-12">
                                <label >Principais Atividades</label>
                                <textarea className="form-control" id="inputSalarioEmpresaAtual" placeholder="Descrição das principais atividades executadas" name="atividadesUltimaEmpresa" maxLength="200" onChange={handleInputChange}/>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-4">
                                <label >Motivo da Saída</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="cnhsim" className="form-check-input  " value="Demitiu-se" maxLength="28" name="tipoSaidaUltimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Demitiu-se</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="cnhnao" className="form-check-input  " value="Foi Demitido" name="tipoSaidaUltimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Foi Demitido</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group col-md-8">
                                <label >Por que?</label>
                                <input type="text" className="form-control" id="idMotivoSaida" placeholder="Motivo da Saída" name="motivoSaidaUltimaEmpresa" maxLength="28" onChange={handleInputChange}/>
                            </div>
                        </div>
                        <br />


                        <div className="h6 card-header text-left col-md-12 bg-secondary">
                            Penúltima(Opcional)
                        </div>
                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-8">
                                <label >Empresa</label>
                                <input type="text" className="form-control" id="inputEmpresaAtual" placeholder="Penúltima empresa" maxLength="60" name="penultimaEmpresa" onChange={handleInputChange}/>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Contato</label>
                                <input type="text" className="form-control" id="inputContaroEmpresaAtual" placeholder="Contato da empresa" maxLength="48" name="contatoPenultimaEmpresa" onChange={handleInputChange}/>
                            </div>
                        </div>

                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-8">
                                <label >Cargo</label>
                                <input type="text" className="form-control" id="inputCargoEmpresaAtual" placeholder="Cargo ocupado" name="cargoPenultimaEmpresa" maxLength="48" onChange={handleInputChange}/>
                            </div>

                            <div className="form-group form-group col-md-4">
                                <label >Período</label>
                                <div className="form-row pl-1 pr-1 ">
                                    <input type="date" className="form-control col-md-6 pl-1 pr-1" id="inputData1" name="inicioPenultimaEmpresa" onChange={handleInputChange}/>
                                    <input type="date" className="form-control col-md-6 pl-1 pr-1" id="inputData2" name="finalPenultimaEmpresa" onChange={handleInputChange}/>
                                </div>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1">
                            <div className="form-group form-group col-md-4">
                                <label >Salário</label>
                                <input type="number" className="form-control" id="inputSalarioEmpresaAtual" placeholder="Último salário" pattern="^\d*(\.\d{0,2})?$" name="salarioPenultimaEmpresa" onChange={handleInputDecimalChange}/>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Recebia Comissão?</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="ComissaoCargo2Sim" className="form-check-input  " value="Sim"  name="comissaoPenultimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Sim</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="ComissaoCargo2Nao" className="form-check-input  " value="Não" name="comissaoPenultimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Não</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Foi Promovido?</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="PromovidoCargo2Sim" className="form-check-input  " value="Sim"  name="promovidoPenultimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Sim</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="PromovidoCargo2Nao" className="form-check-input  " value="Não" name="promovidoPenultimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Não</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1">
                            <div className="form-group form-group col-md-12">
                                <label >Principais Atividades</label>
                                <textarea className="form-control" id="inputSalarioEmpresaAtual" placeholder="Descrição das principais atividades executadas" name="atividadesPenultimaEmpresa" maxLength="200" onChange={handleInputChange}/>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1">
                            <div className="form-group form-group col-md-4">
                                <label >Motivo da Saída</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="cnhsim" className="form-check-input  " value="Demitiu-se"  name="tipoSaidaPenultimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Demitiu-se</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="cnhnao" className="form-check-input  " value="Foi Demitido" name="tipoSaidaPenultimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Foi Demitido</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group col-md-8">
                                <label >Por que?</label>
                                <input type="text" className="form-control" id="inputSalarioEmpresaAtual" placeholder="Motivo da Saída" name="motivoSaidaPenultimaEmpresa" maxLength="25" onChange={handleInputChange}/>
                            </div>
                        </div>

                        <br />
                        <div className="h6 card-header text-left col-md-12 bg-secondary">
                            Antepenúltima(Opcional)
                        </div>
                        <div className="form-row pl-1 pr-1">
                            <div className="form-group form-group col-md-8">
                                <label >Empresa</label>
                                <input type="text" className="form-control" id="inputEmpresaAtual" placeholder="Antepenúltima empresa" name="antepenultimaEmpresa" maxLength="60" onChange={handleInputChange}/>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Contato</label>
                                <input type="text" className="form-control" id="inputContaroEmpresaAtual" placeholder="Contato da empresa" maxLength="48" name="contatoAntepenultimaEmpresa" onChange={handleInputChange}/>
                            </div>
                        </div>

                        <div className="form-row pl-1 pr-1">
                            <div className="form-group form-group col-md-8">
                                <label >Cargo</label>
                                <input type="text" className="form-control" id="inputCargoEmpresaAtual" placeholder="Cargo ocupado" name="cargoAntepenultimaEmpresa" maxLength="48" onChange={handleInputChange}/>
                            </div>

                            <div className="form-group form-group col-md-4">
                                <label >Período</label>
                                <div className="form-row pl-1 pr-1">
                                    <input type="date" className="form-control col-md-6 pl-1 pr-1" id="inputData1" name="inicioAntepenultimaEmpresa" onChange={handleInputChange}/>
                                    <input type="date" className="form-control col-md-6 pl-1 pr-1" id="inputData2" name="finalAntepenultimaEmpresa" onChange={handleInputChange}/>
                                </div>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1">
                            <div className="form-group form-group col-md-4">
                                <label >Salário</label>
                                <input type="number" className="form-control" id="inputSalarioEmpresaAtual" placeholder="Último salário" pattern="^\d*(\.\d{0,2})?$" name="salarioAntepenultimaEmpresa" onChange={handleInputDecimalChange}/>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Recebia Comissão?</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="ComissaoCargo3Sim" className="form-check-input  " value="Sim"  name="comissaoAntepenultimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Sim</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="ComissaoCargo3Nao" className="form-check-input  " value="Não" name="AntepenultimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Não</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Foi Promovido?</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="PromovidoCargo3Sim" className="form-check-input  " value="Sim"  name="promovidoAntepenultimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Sim</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="PromovidoCargo3Nao" className="form-check-input  " value="Não" name="promovidoAntepenultimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Não</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1">
                            <div className="form-group form-group col-md-12">
                                <label >Principais Atividades</label>
                                <textarea className="form-control" id="inputSalarioEmpresaAtual" placeholder="Descrição das principais atividades executadas" name="atividadesAntepenultimaEmpresa" maxLength="200" onChange={handleInputChange}/>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1">
                            <div className="form-group form-group col-md-4">
                                <label >Motivo da Saída</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="cnhsim" className="form-check-input" value="Demitiu-se" name="tipoSaidaAntepenultimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Demitiu-se</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="cnhnao" className="form-check-input  " value="Foi Demitido" name="tipoSaidaAntepenultimaEmpresa" onChange={handleInputChange}/>
                                        <label className="form-check-label">Foi Demitido</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group col-md-8">
                                <label >Por que?</label>
                                <input type="text" className="form-control" id="inputSalarioEmpresaAtual" placeholder="Motivo da Saída" name="motivoSaidaAntepenultimaEmpresa" maxLength="25" onChange={handleInputChange}/>
                            </div>
                        </div>



                        <div className="h6 card-header text-left col-md-12 bg-secondary">
                            Experiência(Opcional)
                        </div>
                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-8">
                                <label >Empresa</label>
                                <input type="text" className="form-control" id="inputEmpresaAtual04" placeholder="Empresa onde trabalhou" name="empresa04" maxLength="60" onChange={handleInputChange}/>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Contato</label>
                                <input type="text" className="form-control" id="inputContaroEmpresaAtual04" placeholder="Contato da empresa" maxLength="48" name="contatoEmpresa04" onChange={handleInputChange}/>
                            </div>
                        </div>

                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-8">
                                <label >Cargo</label>
                                <input type="text" className="form-control" id="inputCargoEmpresaAtual04" placeholder="Cargo ocupado" name="cargoEmpresa04" maxLength="48" onChange={handleInputChange}/>
                            </div>

                            <div className="form-group form-group col-md-4">
                                <label >Período</label>
                                <div className="form-row pl-1 pr-1 ">
                                    <input type="date" className="form-control col-md-6 pl-1 pr-1" id="inputData104" name="inicioEmpresa04" onChange={handleInputChange}/>
                                    <input type="date" className="form-control col-md-6 pl-1 pr-1" id="inputData204" name="finalEmpresa04" onChange={handleInputChange}/>
                                </div>
                            </div>
                        </div>


                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-4">
                                <label >Salário</label>
                                <input type="number" className="form-control" id="inputSalarioEmpresaAtual04" placeholder="Último salário" pattern="^\d*(\.\d{0,2})?$" name="salarioEmpresa04" onChange={handleInputDecimalChange}/>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Recebia Comissão?</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="ComissaoCargo1Sim04" className="form-check-input  " value="Sim"  name="comissaoEmpresa04" onChange={handleInputChange}/>
                                        <label className="form-check-label">Sim</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="ComissaoCargo1Nao04" className="form-check-input  " value="Não" name="comissaoEmpresa04" onChange={handleInputChange}/>
                                        <label className="form-check-label">Não</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Foi Promovido?</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="PromovidoCargo1Sim04" className="form-check-input  " value="Sim"  name="promovidoEmpresa04" onChange={handleInputChange}/>
                                        <label className="form-check-label">Sim</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="PromovidoCargo1Nao04" className="form-check-input  " value="Não" name="promovidoEmpresa04" onChange={handleInputChange}/>
                                        <label className="form-check-label">Não</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-12">
                                <label >Principais Atividades</label>
                                <textarea className="form-control" id="inputSalarioEmpresaAtual04" placeholder="Descrição das principais atividades executadas" name="atividadesEmpresa04" maxLength="200" onChange={handleInputChange}/>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-4">
                                <label >Motivo da Saída</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="tipoSaida04" className="form-check-input  " value="Demitiu-se"  name="tipoSaidaEmpresa04" onChange={handleInputChange}/>
                                        <label className="form-check-label">Demitiu-se</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="cnhnao" className="form-check-input  " value="Foi Demitido" name="tipoSaidaEmpresa04" onChange={handleInputChange}/>
                                        <label className="form-check-label">Foi Demitido</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group col-md-8">
                                <label >Por que?</label>
                                <input type="text" className="form-control" id="idMotivoSaida" placeholder="Motivo da Saída" name="motivoSaidaEmpresa04" maxLength="28" onChange={handleInputChange}/>
                            </div>
                        </div>
                        <br />




                        <div className="h6 card-header text-left col-md-12 bg-secondary">
                            Experiência(Opcional)
                        </div>
                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-8">
                                <label >Empresa</label>
                                <input type="text" className="form-control" id="inputEmpresaAtual04" placeholder="Empresa onde trabalhou" name="empresa05" maxLength="60" onChange={handleInputChange}/>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Contato</label>
                                <input type="text" className="form-control" id="inputContaroEmpresaAtual04" placeholder="Contato da empresa" maxLength="48" name="contatoEmpresa05" onChange={handleInputChange}/>
                            </div>
                        </div>

                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-8">
                                <label >Cargo</label>
                                <input type="text" className="form-control" id="inputCargoEmpresaAtual04" placeholder="Cargo ocupado" name="cargoEmpresa05" maxLength="48" onChange={handleInputChange}/>
                            </div>

                            <div className="form-group form-group col-md-4">
                                <label >Período</label>
                                <div className="form-row pl-1 pr-1 ">
                                    <input type="date" className="form-control col-md-6 pl-1 pr-1" id="inputData104" name="inicioEmpresa05" onChange={handleInputChange}/>
                                    <input type="date" className="form-control col-md-6 pl-1 pr-1" id="inputData204" name="finalEmpresa05" onChange={handleInputChange}/>
                                </div>
                            </div>
                        </div>


                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-4">
                                <label >Salário</label>
                                <input type="number" className="form-control" id="inputSalarioEmpresaAtual04" placeholder="Último salário" pattern="^\d*(\.\d{0,2})?$" name="salarioEmpresa05" onChange={handleInputDecimalChange}/>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Recebia Comissão?</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="ComissaoCargo1Sim04" className="form-check-input  " value="Sim"  name="comissaoEmpresa05" onChange={handleInputChange}/>
                                        <label className="form-check-label">Sim</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="ComissaoCargo1Nao04" className="form-check-input  " value="Não" name="comissaoEmpresa05" onChange={handleInputChange}/>
                                        <label className="form-check-label">Não</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group col-md-4">
                                <label >Foi Promovido?</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="PromovidoCargo1Sim04" className="form-check-input  " value="Sim"  name="promovidoEmpresa05" onChange={handleInputChange}/>
                                        <label className="form-check-label">Sim</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="PromovidoCargo1Nao04" className="form-check-input  " value="Não" name="promovidoEmpresa05" onChange={handleInputChange}/>
                                        <label className="form-check-label">Não</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-12">
                                <label >Principais Atividades</label>
                                <textarea className="form-control" id="inputSalarioEmpresaAtual04" placeholder="Descrição das principais atividades executadas" name="atividadesEmpresa05" maxLength="200" onChange={handleInputChange}/>
                            </div>
                        </div>
                        <div className="form-row pl-1 pr-1 ">
                            <div className="form-group form-group col-md-4">
                                <label >Motivo da Saída</label>
                                <div className="form-group text-center col-md-12">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="tipoSaida04" className="form-check-input  " value="Demitiu-se"  name="tipoSaidaEmpresa05" onChange={handleInputChange}/>
                                        <label className="form-check-label">Demitiu-se</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="cnhnao" className="form-check-input  " value="Foi Demitido" name="tipoSaidaEmpresa05" onChange={handleInputChange}/>
                                        <label className="form-check-label">Foi Demitido</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-group col-md-8">
                                <label >Por que?</label>
                                <input type="text" className="form-control" id="idMotivoSaida" placeholder="Motivo da Saída" name="motivoSaidaEmpresa05" maxLength="25" onChange={handleInputChange}/>
                            </div>
                        </div>
                        <br />

                    <div className="card">
                        <div className="h4 card-header text-center col-md-12 bg-primary">
                            Informações Adicionais
                        </div>
                        <div className="form-row pl-1 pr-1">
                            <div className="form-group col-md-9">
                                <label class="required">Como ficou sabendo da vaga?</label>
                                <div className="form-group text-center col-md-12">
                                        <div className="custom-control custom-switch custom-control-inline">
                                            <input type="radio" id="anuncio" className="form-check-input  " value="Anúncio em site de emprego"  name="comoFicouSabendo" required onChange={handleInputChange}/>
                                            <label className="form-check-label">Anúncio em site de emprego</label>
                                        </div>
                                        <div className="custom-control custom-switch custom-control-inline">
                                            <input type="radio" id="siteDom" className="form-check-input  " value="Trabalhe conosco no site do Dom Atacadista" name="comoFicouSabendo" required onChange={handleInputChange}/>
                                            <label className="form-check-label">Trabalhe conosco no site do Dom Atacadista</label>
                                        </div>
                                        <div className="custom-control custom-switch custom-control-inline">
                                            <input type="radio" id="siteDom" className="form-check-input  " value="Indicação" name="comoFicouSabendo" required onChange={handleInputChange}/>
                                            <label className="form-check-label">Indicação</label>
                                        </div>
                                </div>
                            </div>
                        
                            <div className="form-group col-md-3">
                                <label >Indicado por?</label>
                                <input type="text" className="form-control" id="inputIndicador" placeholder="Indicado Por" name="indicador" maxLength="30" onChange={handleInputChange} />
                            </div>
                        </div>

                        <div className="form-row pl-1 pr-1">
                            <div className="form-group col-md-2">
                                <label class="required">Já trabalhou no Dom?</label>
                                <div className="custom-control custom-switch custom-control-inline">
                                    <input type="radio" id="trabalhouSim" className="form-check-input  " value="Sim"  name="jaTrabalhou" required onChange={handleInputChange}/>
                                    <label className="form-check-label">Sim</label>
                                </div>
                                <div className="custom-control custom-switch custom-control-inline">
                                    <input type="radio" id="trabalhouNao" className="form-check-input  " value="Não" name="jaTrabalhou" required onChange={handleInputChange}/>
                                    <label className="form-check-label">Não</label>
                                </div>
                            </div>

                            <div className="form-group col-md-4">
                                <label >Se sim, em qual Filial?</label>
                                <input type="text" className="form-control" id="inputOnde" placeholder="Qual filial" maxLength="30" name="filialTrabalhoAnterior" onChange={handleInputChange} />
                            </div>
                        </div>

                        <div className="form-row pl-1 pr-1">
                            <div className="form-group col-md-4">
                                <label class="required">Possui deficiência?</label>
                                <div className="form-row pl-1 pr-1">
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="deficienciaSim" className="form-check-input  " value="Sim"  name="deficiente" required onChange={handleInputChange}/>
                                        <label className="form-check-label">Sim</label>
                                    </div>
                                    <div className="custom-control custom-switch custom-control-inline">
                                        <input type="radio" id="deficienciaNao" className="form-check-input  " value="Não" name="deficiente" required onChange={handleInputChange}/>
                                        <label className="form-check-label">Não</label>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group col-md-2">
                                <label >Qual?</label>
                                <div className="form-row pl-1 pr-1">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="Física" name="deficienciaFisica" onChange={handleInputChange}/>
                                        <label class="form-check-label" for="inlineCheckbox1">Física</label>
                                    </div>
                                </div>
                                <div className="form-row pl-1 pr-1">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="Visual" name="deficienciaVisual" onChange={handleInputChange}/>
                                        <label class="form-check-label" for="inlineCheckbox1">Visual</label>
                                    </div>
                                </div>
                                <div className="form-row pl-1 pr-1">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="Auditiva" name="deficienciaAuditiva" onChange={handleInputChange}/>
                                        <label class="form-check-label" for="inlineCheckbox1">Auditiva</label>
                                    </div>
                                </div>
                                <div className="form-row pl-1 pr-1">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="Mental" name="deficienciaMental" onChange={handleInputChange}/>
                                        <label class="form-check-label" for="inlineCheckbox1">Mental</label>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>

                <div class="btn-group-toggle" data-toggle="buttons">
                    <br></br>
                    <button type="submit" class="btn btn-primary btn-lg btn-block" formAction="submit">Enviar Curriculum</button>
                    <br></br>
                </div>
                <br/>
            </div>
            </form>
            <Footer />
        </>
    );
}

export default Curriculum;